import React from 'react';
import styles from './index.module.scss';

const Consumptions = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='32' height='26' viewBox='0 0 32 26'>
            <g transform='translate(-14 -14)'>
                <path
                    d='M24.158,40V32.909H19.895c-1.6,0-3.1-1-4.213-2.827A12.885,12.885,0,0,1,14,23.455a12.885,12.885,0,0,1,1.682-6.628C16.8,15,18.292,14,19.895,14H40.105c1.6,0,3.1,1,4.213,2.827A12.884,12.884,0,0,1,46,23.455s0,.041,0,.054v.752h0V40Z'
                    className={styles.dark}
                />
                <path
                    d='M35.018,47.19c-2.52,0-4.673-3.215-5.009-7.478l-.046-.58V38.058l.046-.58C30.345,33.215,32.5,30,35.018,30H52.256l-.73.884a8.4,8.4,0,0,0-.689.97,12.582,12.582,0,0,0-1.679,5.7l-.033.5v1.074l.033.5a12.582,12.582,0,0,0,1.679,5.7,8.4,8.4,0,0,0,.689.97l.73.884Z'
                    transform='translate(-15.123 -15.14)'
                    className={styles.light}
                />
                <ellipse
                    cx='1.365'
                    cy='2.321'
                    rx='1.365'
                    ry='2.321'
                    transform='translate(39.098 21.429)'
                />
                <ellipse
                    cx='1.365'
                    cy='2.321'
                    rx='1.365'
                    ry='2.321'
                    transform='translate(39.098 21.429)'
                />
                <ellipse
                    cx='1.365'
                    cy='2.321'
                    rx='1.365'
                    ry='2.321'
                    transform='translate(39.098 21.429)'
                />
                <ellipse
                    cx='1.365'
                    cy='2.321'
                    rx='1.365'
                    ry='2.321'
                    transform='translate(39.098 21.429)'
                />
                <path
                    d='M223,308.222v-6.017h15.105a5.106,5.106,0,0,0,4.1-2.479l.955-1.37v9.865Z'
                    transform='translate(-198 -269.082)'
                    className={styles.light}
                />
                <path
                    d='M419.053,47.19c-1.383,0-2.676-.945-3.64-2.661A12.313,12.313,0,0,1,414,38.6a12.313,12.313,0,0,1,1.413-5.934c.964-1.716,2.257-2.661,3.64-2.661s2.676.945,3.64,2.661a12.314,12.314,0,0,1,1.413,5.934,12.314,12.314,0,0,1-1.413,5.934C421.729,46.245,420.436,47.19,419.053,47.19Z'
                    transform='translate(-378.947 -15.14)'
                    className={styles.light}
                />
                <ellipse
                    cx='1.365'
                    cy='2.321'
                    rx='1.365'
                    ry='2.321'
                    transform='translate(39.098 21.429)'
                    className={styles.dark}
                />
                <rect
                    width='2.105'
                    height='1.289'
                    transform='translate(21.852 22.81)'
                    className={styles.dark}
                />
                <rect
                    width='2.105'
                    height='1.289'
                    transform='translate(24.931 22.81)'
                    className={styles.dark}
                />
                <rect
                    width='2.105'
                    height='1.289'
                    transform='translate(28.009 22.81)'
                    className={styles.dark}
                />
                <rect
                    width='2.105'
                    height='1.289'
                    transform='translate(31.088 22.81)'
                    className={styles.dark}
                />
                <rect
                    width='2.105'
                    height='1.289'
                    transform='translate(18.774 22.81)'
                    className={styles.dark}
                />
                <rect
                    width='2.105'
                    height='1.289'
                    transform='translate(15.695 22.81)'
                    className={styles.dark}
                />
            </g>
        </svg>
    );
};

export default Consumptions;
